import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

export function getBaseUrl() {
    return document.getElementsByTagName('base')[0].href;
}

export function getCIBaseUrl() {
    return 'https://ban8-pdevbanapps.tosm.ttu.edu/ITIS/CampusInfoAdmin/';
}

export function getPreProdBaseUrl() {
    return 'https://ban8-udevbanapps.tosm.ttu.edu/ITIS/CampusInfoAdmin/';
}

export function getProdBaseUrl() {
    return 'https://banapps.texastech.edu/ITIS/CampusInfoAdmin/';
}

const providers = [
    { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] },
    { provide: 'CI_BASE_URL', useFactory: getCIBaseUrl, deps: [] },
    { provide: 'PREPROD_BASE_URL', useFactory: getPreProdBaseUrl, deps: [] },
    { provide: 'PROD_BASE_URL', useFactory: getProdBaseUrl, deps: [] }
];

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic(providers).bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
